import { useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Switch, InputDate, Label, RadioGroup } from '@teo/components';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { Userwithorganisationwithidps } from '@/models';

const SharingSettingsStep = ({ state, setLoadStep, loadedStep }: any) => {
  const {
    emailCertificate,
    setEmailCertificate,
    lpgroupAccess,
    setLpgroupAccess,
    lpEndDate,
    setLpEndDate,
    isMandatory,
    setIsMandatory,
    lpStartDate,
    setLpStartDate,
  } = state;

  const { t } = useTranslation();
  const { auth } = useContext(AuthContext);
  const authUser = auth?.user as Userwithorganisationwithidps;

  useEffect(() => {
    setTimeout(() => {
      setLoadStep(false);
      loadedStep();
    }, 100);
  }, []);

  return (
    <>
      <article className="prose flex flex-col ">
        <h3 className="text-base">
          {t('pages.follow_learningpath.step_3.title')}
        </h3>
        <p className="pt-3 text-sm text-grey-07">
          {t('pages.follow_learningpath.step_3.subtitle')}
        </p>
      </article>
      <>
        <div className="mt-7 flex flex-col gap-5 pr-2 sm:flex-row lg:pr-0">
          <div className="basis-1/2" data-testid="dateStart">
            <Label htmlFor="dateStart">
              {t('pages.course_content_flow.step_3.start_day')}{' '}
            </Label>
            <InputDate
              id="dateStart"
              onChange={(date) => {
                if (!date) {
                  setLpStartDate(new Date(Date.now()));
                } else {
                  setLpStartDate(date);
                }
              }}
              value={lpStartDate ? new Date(lpStartDate) : undefined}
              variant="date"
            />
          </div>
          <div className="basis-1/2" data-testid="dateEnd">
            <Label htmlFor="dateEnd">
              {t('pages.follow_learningpath.step_3.end_day')}{' '}
              <span className="font-normal text-grey-05">
                ({t('pages.course_content_flow.step_3.optional')})
              </span>
            </Label>
            <InputDate
              id="dateEnd"
              onChange={(date) => {
                setLpEndDate(date ? date : null);
              }}
              value={lpEndDate}
              variant="date"
            />
          </div>
        </div>
        <div className="mt-5 flex flex-row items-center gap-4 rounded-lg border border-grey-02 p-4">
          <div data-testid="mandatory">
            <Switch
              checked={isMandatory}
              onChange={(isCheck) => {
                setIsMandatory(isCheck);
              }}
            />
          </div>
          <div>
            <h4 className="pb-2 font-normal">
              {t('pages.follow_learningpath.step_3.mandatory_follow')}
            </h4>
            <p className="text-xs text-grey-05">
              {t(
                'pages.follow_learningpath.step_3.mandatory_follow_description'
              )}
            </p>
          </div>
        </div>

        <RadioGroup
          label=""
          onChange={(value: string) => {
            setLpgroupAccess(value);
          }}
          value={lpgroupAccess}
        >
          <div className="flex flex-col gap-5 sm:flex-row">
            <div
              className={`flex basis-1/2 items-center rounded-lg border border-grey-02 p-3 ${
                lpgroupAccess == 'protected' && 'border-secondary-04'
              }`}
            >
              <RadioGroup.Option value="protected" className="test">
                <span className="inline-block max-w-[270px] text-sm">
                  {t('pages.course_content_flow.step_3.public')}&nbsp;
                  <span className="block font-semibold">
                    {authUser?.organisationName && authUser?.organisationName}
                  </span>
                </span>
              </RadioGroup.Option>
            </div>
            <div
              className={`flex basis-1/2 items-center rounded-lg border border-grey-02 p-3 ${
                lpgroupAccess == 'private' && 'border-secondary-04'
              }`}
            >
              <RadioGroup.Option value="private">
                <span className="text-sm">
                  {t('pages.course_content_flow.step_3.ivite')}
                </span>
              </RadioGroup.Option>
            </div>
          </div>
        </RadioGroup>

        {/* <div className="mt-5 flex flex-row items-center gap-4 rounded-lg border border-grey-02 p-4">
          <div data-testid="certificate">
            <Switch
              checked={emailCertificate}
              onChange={(isCheck) => {
                setEmailCertificate(isCheck);
              }}
            />
          </div>
          <div>
            <h4 className="pb-2 font-normal">
              {' '}
              {t('pages.follow_learningpath.step_3.certificate')}
            </h4>
            <p className="text-xs text-grey-05">
              {t('pages.follow_learningpath.step_3.certificate_description')}
            </p>
          </div>
        </div> */}
      </>
    </>
  );
};

export default SharingSettingsStep;
